import React from 'react';
import clsx from "clsx";

/**
 * Storybook QuantityInput 2025-02-24
 * Modifications
 *  - Translated from TypeScript
 *  - Changed imports
 *  - Added arrow style prop
 */

const Collapsible = ({
  className,
  label,
  labelClassName,
  contentClassName,
  children,
  onChange,
  isOpen,
  id,
  arrowStyle,
}) => {
  const handleOnClick = () => {
    onChange && onChange(!isOpen);
  };
  const uniqueId = id;
  return (
    <div className={clsx("collapsible", className)}>
      <button
        className={clsx("collapsible__button", labelClassName)}
        aria-expanded={isOpen}
        onClick={handleOnClick}
        id={uniqueId}
        aria-controls={`accordion-${uniqueId}`}
      >
        <span className="collapsible__button__label">{label}</span>
        <span
          className={clsx(
            "collapsible__button__icon",
            arrowStyle && `collapsible__button__icon--${arrowStyle}`,
            isOpen ? "collapsible__button__icon--open" : "collapsible__button__icon--closed"
          )}
        ></span>
      </button>
      <div
        className={clsx(
          "collapsible__content",
          isOpen ? "collapsible__content--open" : "collapsible__content--closed",
          contentClassName
        )}
        id={`accordion-${uniqueId}`}
        aria-hidden={!isOpen}
      >
        <div className="collapsible__content-inner">{children}</div>
      </div>
    </div>
  );
};

export default Collapsible;